
import React from 'react';
import { ChatButton } from '@/components/chat/ChatButton';
import { Header } from '@/components/landing/Header';
import { HeroSection } from '@/components/landing/HeroSection';
import { FeaturesSection } from '@/components/landing/FeaturesSection';
import { StatsSection } from '@/components/landing/StatsSection';
import { ProcessSection } from '@/components/landing/ProcessSection';
import { TestimonialsSection } from '@/components/landing/TestimonialsSection';
import { CallToActionSection } from '@/components/landing/CallToActionSection';
import { ValuePropsSection } from '@/components/landing/ValuePropsSection';
import { ContactSection } from '@/components/landing/ContactSection';
import { Footer } from '@/components/landing/Footer';
import { BackgroundEffects } from '@/components/landing/BackgroundEffects';

export default function LandingPage() {
  // Debug: Log that LandingPage is rendering
  console.log('LandingPage: Component is rendering');

  const stats = [
    { value: "99%", label: "Customer satisfaction" },
    { value: "85%", label: "Productivity increase" },
    { value: "40+", label: "Available tools" },
    { value: "24/7", label: "Support" }
  ];

  return (
    <div className="bg-background text-foreground relative overflow-hidden">
      <BackgroundEffects />
      <Header />
      <HeroSection />
      <FeaturesSection />
      <StatsSection stats={stats} />
      <ProcessSection />
      <TestimonialsSection />
      <ValuePropsSection />
      <CallToActionSection />
      <ContactSection />
      <Footer />
      
      {/* Chat Button - Fixed positioned for landing page visitors */}
      <ChatButton />
    </div>
  );
}
